// extracted by mini-css-extract-plugin
export default {"btnNorm__icon":"ButtonNormBody_btnNorm__icon__SF8RU","btnNorm__cell":"ButtonNormBody_btnNorm__cell__5KILs"};